import { render, staticRenderFns } from "./GarantiaStats.vue?vue&type=template&id=7ebb20f6&scoped=true"
import script from "./GarantiaStats.vue?vue&type=script&lang=js"
export * from "./GarantiaStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebb20f6",
  null
  
)

export default component.exports